export default __webpack_public_path__ + "static/media/misc-closetA-768w.becc4438.webp";